module.exports = __webpack_public_path__ + "static/media/gray-pin.e9bf9bc9.png";